module.exports = "{{ $column.title(this) }}\n<gg-info-icon text=\"{{$column.titleAlt(this)}}\" placement='right'></gg-info-icon>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ng-table/helptextHeaderCell.html
 ** module id = 874
 ** module chunks = 0
 **/